exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style_taskDetailsContainer__LrSRu{display:flex;flex-direction:row;min-width:180px;padding:.5rem;margin:.25rem 0;justify-content:left}.style_taskDetailsContainer__LrSRu .style_details__1fsJb{display:flex;flex-direction:column;justify-content:space-between;align-items:flex-start;padding-left:.5rem}.style_taskDetailsContainer__LrSRu .style_description__26x0p{color:#333;font-weight:500;font-size:.875rem;text-align:left}.style_taskDetailsContainer__LrSRu .style_date__3EL-h{color:#666;font-weight:400;font-size:.6875rem;white-space:nowrap}.style_stripTopBottomPadding__XDGZz{padding:0 .5rem;margin:0}", ""]);

// exports
exports.locals = {
	"taskDetailsContainer": "style_taskDetailsContainer__LrSRu",
	"details": "style_details__1fsJb",
	"description": "style_description__26x0p",
	"date": "style_date__3EL-h",
	"stripTopBottomPadding": "style_stripTopBottomPadding__XDGZz"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/TaskDetails/style.less
// module id = 1562
// module chunks = 8